import * as React from "react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";
import { Download, Printer, FileText, MoreHorizontal, User2Icon, MoreVerticalIcon } from "lucide-react";

export type OrderActionMenuItem = {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  danger?: boolean;
  disabled?: boolean;
};

type OrderActionBarProps = {
  onDownloadInvoice?: () => void;
  onPrintInvoice?: () => void;
  onShowReceipt?: () => void;

  menuItems?: OrderActionMenuItem[];
  className?: string;
};

export function OrderActionBar({
  onDownloadInvoice,
  onPrintInvoice,
  onShowReceipt,
  menuItems = [],
  className,
}: OrderActionBarProps) {
  const hasMenu = menuItems.length > 0;

  const baseButtonClasses =
    "rounded-none border-r border-slate-200 text-slate-700 hover:bg-blue-500 hover:text-white";

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-md border border-slate-200 overflow-hidden bg-white shadow-sm",
        className
      )}
    >
      {/* Invoice */}
      {/* I comment this out because we don't need invoice currently and avoid overflow issue on mobile */}
      {/* {onDownloadInvoice && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onDownloadInvoice}
          className={baseButtonClasses}
        >
          <Download className="h-4 w-4 mr-2" />
          Invoice
        </Button>
      )} */}



      {onShowReceipt && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onShowReceipt}
          className={cn(
            "rounded-none text-slate-700 hover:bg-blue-500 hover:text-white",
            !hasMenu && "border-l border-slate-200" // if it's the last one
          )}
        >
          <FileText className="h-4 w-4 mr-2" />
          Delivery Receipt
        </Button>
      )}

      {/* Extra actions dropdown */}
      {hasMenu && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="sm"
              className="h-9 w-9 rounded-none border-l border-slate-200 flex items-center justify-center p-0"
              title="More actions"
            >

              <MoreVerticalIcon className="h-5 w-5 text-gray-500" strokeWidth={2} />
            </Button>
          </DropdownMenuTrigger>

          <DropdownMenuContent
            align="end"
            className="z-50 w-64 bg-white shadow-lg border border-gray-200 rounded-lg p-1"
          >
            {menuItems.map((item, idx) => (
              <React.Fragment key={item.label + idx}>
                {idx > 0 && item.danger && (
                  <DropdownMenuSeparator className="my-1" />
                )}

                <DropdownMenuItem
                  onClick={!item.disabled ? item.onClick : undefined}
                  className={cn(
                    "flex items-center gap-3 px-4 py-2.5 text-[13px] font-medium rounded-md transition-all",
                    item.disabled
                      ? "text-gray-300 cursor-not-allowed bg-gray-50 hover:bg-gray-50"
                      : item.danger
                        ? "text-red-600 hover:bg-red-50 hover:text-red-700 cursor-pointer"
                        : "text-gray-700 hover:bg-slate-50 hover:text-slate-900 cursor-pointer"
                  )}
                >
                  {item.icon && (
                    <span
                      className={cn(
                        "h-5 w-5 flex items-center justify-center",
                        item.disabled && "opacity-40"
                      )}
                    >
                      {item.icon}
                    </span>
                  )}
                  <span>{item.label}</span>
                </DropdownMenuItem>
              </React.Fragment>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
